class WebGlBufferWrapper {
	public buffer:WebGLBuffer = null;
	public itemSize:number = 0;
	public length:number = 0;
	public name:string = '';
}